import React from 'react'

const CardTemplate = () => {
    return (
        <div>
            Card Templates
        </div>
    )
}

export default CardTemplate;
